<script>
  export let icon;
  export let onEdit;
  export let onDelete;
  export let deletingId;

  import { randomString } from "../js/randomString";
</script>

<div class="cityCodeItemContainer">
  <div class="info">
    <img src={icon.icon + "?" + randomString(10)} alt="Platform Icon" />
    <span>{icon.name}</span>
  </div>
  <div class="options">
    <img
      class="fadedButton"
      src="/images/edit.svg"
      alt="Edit"
      on:click={onEdit}
    />
    <img
      class="fadedButton"
      src={deletingId === icon.id
        ? "/images/trash-red.svg"
        : "/images/trash.svg"}
      alt="Remove"
      on:click={onDelete}
    />
  </div>
</div>

<style>
  div.cityCodeItemContainer {
    display: flex;
    margin-bottom: 10px;
  }

  div.info {
    width: 90%;
    font-size: 14px;
    color: var(--labit-card-gray);
    display: flex;
    align-items: center;
  }

  div.info img {
    height: 20px;
    align-self: center;
    margin-right: 5px;
  }

  div.codes {
    display: flex;
    font-size: 12px;
  }

  div.options {
    width: 20%;
    display: flex;
    justify-content: flex-end;
  }

  div.options img {
    width: 20px;
    margin-left: 5px;
  }
</style>
